//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, changeStatus, _STATUS } from '@/apis/invoice'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [],
            },
            searchQuery: {
                status: ''
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '申請人姓名', dataIndex: 'name', key: 'name', width: 180, },
            { title: '發票金額', dataIndex: 'amount', key: 'amount', width: 180, },
            { title: '發票類型', key: 'type', width: 180, scopedSlots: { customRender: 'typeSlot' } },
            { title: '擡頭', dataIndex: 'taxTitle', key: 'taxTitle', width: 260, },
            { title: '統壹編號', dataIndex: 'taxId', key: 'taxId', width: 260, },
            { title: '郵箱', dataIndex: 'email', key: 'email', width: 240, },
            { title: '狀態', key: 'status', width: 100, scopedSlots: { customRender: 'statusSlot' }, },
            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];


        // this.records = [
        //     {
        //         "id": 1,
        //         "name": "申請人名稱",
        //         "amount": "發票金額",
        //         "type": "2",
        //         "taxTitle": "擡頭",
        //         "taxId": "統壹編號",
        //         "email": "郵箱",
        //         "createdTime": "2025-07-25 12:00:00",
        //         "status": "1"
        //     },
        //     {
        //         "id": 2,
        //         "name": "申請人名稱",
        //         "amount": "發票金額",
        //         "type": "1",
        //         "taxTitle": "擡頭",
        //         "taxId": "統壹編號",
        //         "email": "郵箱",
        //         "transactionId": "交易ID[充值訂單ID]",
        //         "createdTime": "2025-07-25 12:00:00",
        //         "status": "6"
        //     }
        // ]
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageConfig() {
            try {
                let _status = [];

                Object.keys(_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _STATUS[value],
                    })
                })
                this.config.status = _status;


            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = this.parseRecords(res.data.records);
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {
            records.forEach(record => {
                record.status_text = this._getStatusText(record.status);
            })

            return records;

        },
        _getStatusText(code) {
            return _STATUS[code] !== undefined ? _STATUS[code] : '';
        },


        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async onStatus(record, status) {
            //edit state
            try {
                const res = await changeStatus(record.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },


        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/activity/edit/${id}`);
            } else {
                this.$router.push('/activity/add');
            }

        }
    }
}
